export const COLUMN_WIDTH = 140;
export const LABEL_COLUMN_WIDTH = 300;
export const SUBJECT_NAME_WIDTH = 240;
export const PLUS_BUTTON_WIDTH = 60;
export const ADD_DROPDOWN_WIDTH = 500;
export const BENCHMARK_MAX_WIDTH = 600;
